import { useSnapshot } from "valtio"
import Select from 'react-select'
import { useState, useEffect } from "react"
import { enquiryStore } from "../enquiry/enquiry-data"
import { configStore } from "../state/CommonState"

const customStyles = {
    control: (provided) => ({
        ...provided,
        minHeight: '30px',
        border: '1px solid #ccc',
    }),

    indicatorSeparator: (provided) => ({
        ...provided,
        display: 'none',
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        display: 'none',
    }),
    option: (provided) => ({
        ...provided,
        height: '30px',
        background: '#fff',
        color: '#363636'
    }),
}

export default function AgCustlist1({ label, record, name, dataList,isChecked, callback = f => f , isValid = true, validationMsg, isDisabled }) {
    const [selectedOption, setSelectedOption] = useState(null)
    const imRecord = useSnapshot(record)
    useSnapshot(enquiryStore)
    let gst1 = 'GSTTBA000000000'
    // useEffect(() => {
        
    //     let entityList = dataList.filter((ele) => ele.gst === imRecord[name])
    //     setSelectedOption(entityList)
       
        
    // }, [dataList, imRecord, name])
    // dataList = dataList.filter(function(x) { return x.gst !== gst1; });

    useEffect(() => {
        let entityList = dataList.filter((ele) => ele.entityId === imRecord['entityId'])
        setSelectedOption(entityList)
    }, [dataList, imRecord, name])

    if(record[name] == ''){
        configStore.checkedEmptyDropdown = true
    }else{
        configStore.checkedEmptyDropdown = false
    }
    console.log(">>>>ischecked",enquiryStore.current.checkAgCustomer,configStore.checkedEmptyDropdown,record[name],record)
    return (
        <div className="field">
            <label className="label is-small" style={{ marginBottom: '0px'}}>{label}</label>
            <div className="control">
                <div className={ isValid ? "label is-small" : "label is-small is-danger"} style={{width:"40em"}}>
                    {
                        dataList !== null  ? <Select
                            // value={enquiryStore.current.gst != '' ?selectedOption : ""}
                            value={selectedOption}
                            options={dataList}
                            onChange={(e) => {
                                record[name] = e ? e.entityId : ""
                                setSelectedOption(e)
                                callback(e ? e.entityId : "")
                            }}
                           
                            // {

                            // }
                            // getOptionLabel={(entityList) => entityList.entityName+" "+entityList.state}
                            
                            // getOptionLabel={(entityList) => {
                            //     if(entityList.state == undefined || entityList.state == "undefined"){
                            //         return entityList.entityName
                            //     }else{
                            //        return entityList.entityName+" "+entityList.state
                            //     }
                            // }}
                            getOptionLabel={(entityList) => {
                                if(entityList.state == undefined || entityList.state == "undefined"){
                                    return entityList.entityName
                                }else{
                                   return entityList.entityName+" "+entityList.state
                                }
                            }}
                            isDisabled={!isDisabled || !isDisabled.disabled ? false : isDisabled.disabled }
                            isSearchable={true}
                            isClearable={true}
                            placeholder={null}
                            styles={customStyles}

                        /> : ""
                    }

                </div>
            </div>
            { !isValid &&  <p class="help is-danger"> { validationMsg || `* Please select one customer` }</p> }
        </div>
    )
}
